/**
 * Saved views (YTI-1926): an élu saves the filters of an accounting page under a name
 * and replays them in one click. Views live server-side, per representative,
 * so they survive logout whatever the "remember my filters" preference.
 */

/** Accounting pages offering saved views. Must match the API page key format. */
export const FILTER_VIEW_PAGE_KEYS = {
  ACCOUNTING_LEDGER: "accounting.ledger",
  ACCOUNTING_STOCK: "accounting.stock",
  ACCOUNTING_MOVEMENTS: "accounting.movements",
  ACCOUNTING_SETTLEMENTS: "accounting.settlements",
  ACCOUNTING_SYNTHESIS: "accounting.synthesis",
} as const;

export type FilterViewPageKey = (typeof FILTER_VIEW_PAGE_KEYS)[keyof typeof FILTER_VIEW_PAGE_KEYS];

export const FILTER_VIEW_NAME_MAX_LENGTH = 60;

/** Router state set when a view is applied: the page remounts on the view's URL. */
export const FILTER_VIEW_APPLIED_STATE_KEY = "filterViewAppliedAt";

export const FILTER_VIEWS_ENDPOINTS = {
  LIST: "/representative_filter_views",
  CREATE: "/representative_filter_views",
  DELETE: "/representative_filter_views/:id",
} as const;

export const FILTER_VIEWS_QUERY_KEYS = {
  all: ["filter-views"] as const,
  list: (pageKey: FilterViewPageKey) => [...FILTER_VIEWS_QUERY_KEYS.all, pageKey] as const,
} as const;
